import { DateTime } from 'luxon';
import React, { FunctionComponent, useMemo } from 'react';
import ListDetails, { Field } from '../../../components/ListDetails';
import { ProfileBadge } from '../../../components/profile-badge';
import { Gift, GiftStatus } from '../../../services/gift-service/types';

/**
 * GiftUser props
 */
interface Props {
  gift: Gift;
}

/**
 * GiftUser Component
 */
const GiftUser: FunctionComponent<Props> = ({ gift }) => {
  const giftInfo = useMemo(() => gift, [gift]);
  const personalInfoFields = useMemo<Field[]>(
    () => [
      { key: 'givername' },
      { key: 'giverEmail' },
      { key: 'receiverName' },
      { key: 'receiverEmail' },
      // { key: 'birthDate' },
      // { key: 'gender' },
      // { key: 'phone' },
    ],
    [],
  );

  const giftInfoFields = useMemo<Field[]>(
    () =>
      [
        { key: 'name', label: 'Product Name' },
        { key: 'giftCode', label: 'Gift Code' },
        { key: 'givername', label: 'Giver Name' },
        { key: 'giverEmail', label: 'Giver Email' },
        { key: 'receiverName', label: 'Receiver Name' },
        { key: 'receiverEmail', label: 'Receiver Email' },
        
        {
          key: 'giftDate',
          label: 'Gift Date & Time (EST)',
          render: (data: Gift) =>
            DateTime.fromJSDate(new Date(data.orderDate))
              .setZone('America/New_York')
              .toFormat('LL-dd-yyyy hh:mm a'),
        },
        { key: 'status', label: 'Status' },
        { key: 'giftMessage', label: 'Gift Message' },
        
        
      ].filter(e => e) as Field[],
    [gift?.giftCode],
  );

  return (
    <div>
      


      <div className="mt-[24px] flex flex-row items-center">
      <span className="material-symbols-outlined text-blue">beenhere</span>
      <span className="text-base text-[#444444] ml-[17px]">Gift info</span>
      </div>

      <div className="mt-[10px]">
        <ListDetails data={gift} fields={giftInfoFields} />
      </div>
    </div>
  );
};

export default GiftUser;
